import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export default function Home() {
  const { me } = useAuth();
  if (!me) return null;
  return (
    <div>
      <h2>Welcome, {me.user.name}</h2>
      <p style={{ color: '#666' }}>
        You're a member of {me.accounts.length} household{me.accounts.length === 1 ? '' : 's'}.
        Funds are tracked per household.
      </p>
      {me.accounts.length === 0 ? (
        <p>
          <Link to="/accounts">Create a household to get started →</Link>
        </p>
      ) : (
        <ul style={{ paddingLeft: 0, listStyle: 'none' }}>
          {me.accounts.map((a) => (
            <li key={a.id} style={{ marginBottom: '0.4rem' }}>
              <strong>{a.name}</strong> ·{' '}
              <Link to={`/accounts/${encodeURIComponent(a.id)}/dashboard`}>dashboard</Link>
              {' · '}
              <Link to={`/accounts/${encodeURIComponent(a.id)}/funds`}>funds</Link>
            </li>
          ))}
        </ul>
      )}
      <p style={{ marginTop: '1.5rem' }}>
        <Link to="/accounts">Manage households →</Link>
      </p>
    </div>
  );
}
